import { createThunkRequest, DELETE, PATCH, POST } from '@webapp/account/src/libs/request';

import type { ForwardLogic } from '@webapp/common/resources/entities/question';

import { getAllQuestions } from '../questions/async';
import { selectCurrentSurveyId } from '../survey/selectors';

export const addCarryForwardLogic = createThunkRequest(
    'carryForward/addLogic',
    async (
        {
            questionId,
            childQuestionId,
            checked,
            type,
        }: {
            questionId: number;
            childQuestionId: number;
            checked: boolean;
            type: string;
        },
        { dispatch, getState },
    ) => {
        const { message, id } = await POST('add/forward_logic', {
            questionId,
            childQuestionId,
            checked,
            details: [],
            type,
        });

        const surveyId = selectCurrentSurveyId(getState());
        dispatch(getAllQuestions({ surveyId }));
        return { message, id: parseInt(id, 10), questionId, childQuestionId, type };
    },
);

export const deleteCarryForwardLogic = createThunkRequest(
    'carryForward/deleteLogic',
    async ({ logicId }: { logicId: number }, { dispatch, getState }) => {
        const { message } = await DELETE(`delete/forward_logic/${logicId}`);
        const surveyId = selectCurrentSurveyId(getState());
        dispatch(getAllQuestions({ surveyId }));
        return { message, logicId };
    },
);

export const editCarryForwardLogic = createThunkRequest(
    'carryForward/editLogic',
    async (
        {
            logicId,
            checked,
            details = [],
            type,
        }: {
            logicId: number;
            checked: boolean;
            details?: Array<{ groupId: number }>;
            type: string;
        },
        { dispatch, getState },
    ) => {
        const { message } = await PATCH(`change/forward_logic`, {
            logicId,
            checked: checked ? 1 : 0,
            details,
            type,
        });
        const surveyId = selectCurrentSurveyId(getState());
        dispatch(getAllQuestions({ surveyId }));
        return { message };
    },
);

export const saveCarryForwardLogic = createThunkRequest(
    'carryForward/saveLogic',
    async (
        {
            deletedLogicIds,
            createdLogics,
            editedLogics,
            type,
        }: {
            deletedLogicIds: Array<number>;
            createdLogics: Array<Omit<ForwardLogic, 'id'>>;
            editedLogics: Array<ForwardLogic>;
            type?: string;
        },
        { dispatch, getState },
    ) => {
        if (deletedLogicIds.length > 0) {
            await Promise.all(
                deletedLogicIds.map((id) =>
                    DELETE(type === 'category' ? `delete/forward_logic_category/${id}` : `delete/forward_logic/${id}`),
                ),
            );
        }
        if (createdLogics.length > 0) {
            await Promise.all(
                createdLogics.map((logic) =>
                    POST('add/forward_logic', {
                        questionId: logic.questionId,
                        childQuestionId: logic.childQuestionId,
                        checked: logic.checked,
                        details: logic.details,
                        type,
                    }),
                ),
            );
        }
        if (editedLogics.length > 0) {
            await Promise.all(
                editedLogics.map((logic) =>
                    PATCH('change/forward_logic', {
                        logicId: logic.id,
                        checked: logic.checked,
                        details: logic.details,
                        type,
                    }),
                ),
            );
        }

        const surveyId = selectCurrentSurveyId(getState());
        dispatch(getAllQuestions({ surveyId }));

        return { message: 'Настройки подстановки успешно сохранены' };
    },
);

export const deleteCarryForwardLogicCategory = createThunkRequest(
    'carryForward/deleteLogicCategory',
    async ({ logicId }: { logicId: number }, { dispatch, getState }) => {
        const { message } = await DELETE(`delete/forward_logic_category/${logicId}`);
        const surveyId = selectCurrentSurveyId(getState());
        dispatch(getAllQuestions({ surveyId }));

        return { message, logicId };
    },
);
